<script lang="ts">
  import { slide } from 'svelte/transition';
  import CheckboxGroup from '../checkbox/CheckboxGroup.svelte';
  import type { ComponentType } from 'svelte';

  export let icon: ComponentType | null = null;
  export let dropdownOpen = false;
  export let items: string[] = [];
  export let multiple = false;
  export let multipleLimit = 0;
  export let selectedValue = '';
  export let selectedValues: string[] = [];
</script>

<div
  transition:slide
  class="bg-gray-dark-3 py-2xs absolute inset-0 z-10 h-fit max-h-[188px] overflow-y-scroll rounded"
>
  {#if items?.length > 0}
    {#if multiple}
      <div class="px-lg">
        <CheckboxGroup
          direction="vertical"
          limitEnforced={multipleLimit > 0}
          bind:items
          bind:maxOptions={multipleLimit}
          bind:checked={selectedValues}
          on:change
        />
      </div>
    {:else}
      {#each items as item}
        <button
          type="button"
          on:click={() => {
            selectedValue = item;
            dropdownOpen = false;
          }}
          class="px-lg text-gray-dark-12 focus-within:ring-mint-dark-4 hover:bg-gray-dark-2 focus:border-mint-dark-8 flex w-full items-center gap-x-2 border border-transparent py-2 text-sm leading-5 ring-[3px] ring-transparent"
        >
          {#if icon}
            <svelte:component this={icon} />
          {/if}
          <span>{item}</span>
        </button>
      {/each}
    {/if}
  {/if}
</div>

<style>
  ::-webkit-scrollbar-thumb {
    background: #006d5b;
  }
</style>
